import request from '@/utils/request'

export function login(username, password) {
  return request({
    url: '/user/login',
    method: 'post',
    data: {
      account: username,
      pwd: password
    }
  })
}

export function getLoginUser() {
  return request({
    url: '/user/getLoginUser',
    method: 'get'
  })
}

export function getById(params) {
  return request({
    url: '/user/getbyid',
    method: 'get',
    params
  })
}

export function getNew() {
  return request({
    url: '/user/getnew',
    method: 'get'
  })
}

export function logout() {
  return request({
    url: '/user/logout',
    method: 'get'
  })
}

export function redirect(params) {
  return request({
    url: '/user/humi/redirect',
    method: 'get',
    params
  })
}
export function loginptjk(params){
  return request({
    url: '/humi/redirect?'+params,
    method: 'post'
  })
}


// WEBPACK FOOTER //
// ./src/api/users.js